import { MutationTree } from 'vuex';
import { EDocumentContentMutation } from '@/document-view/document-content/store/document-content.constants';
import { IDocumentContentState } from '@/document-view/document-content/store/document-content.types';

export const mutations: MutationTree<IDocumentContentState> = {
  [EDocumentContentMutation.SetPageWidth](state: IDocumentContentState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
};
